module.exports = __webpack_public_path__ + "img/pledge.b3ff3085.png";